var urlMap = {
	"user": "/user",
	"globalRank": "/getBlobalRank",
	"friendRank": "/getFriendRank",
	"goodsConfig": "/shop/goodsConfig",
	"getMark" : "/user/markInfo",
	"markV2" : "/user/mark",
  	"writeReplay" : "/replay/writeReplay",
	"readReplay": "/replay/readReplay",
	"getUnlockInfo" : "/getUnlockInfo",
	"mockUser" : "/user/mock",
	"mockUserByUUID" : "/xclover/api/login.php",
	// "mockUserByUUID" : "/xclover/api/login2.php?op=mock_user",
	"passLevel" : "/user/update",
	"buy" : "/shop/buy",
	"useProps" : "/user/useProps",
	"startlevel" : "/user/deductEnergy",
	"lotteryInfo" : "/lottery/lotteryInfo",
	"drawLottery" : "/lottery/drawLottery",
	"lotteryReward" : "/lottery/lotteryReward",
	"redraw" : "/lottery/redraw",
	"lotteryExchange" : "/lottery/lotteryExchange",
	"getMsgList" : "/msg",
	"queryUser" : "/user/queryUser",
	"sendMsg" : "/msg/sendMsg",
	"processMsg" : "/msg/processMsg",
	"getFriends" : "/friends",
	"friend" : "/friend",
	"addFriend" : "/friend/add", //仅用于新用户被邀请过来的时候发送请求
	"getInviteFriendsInfo" : "/friend/getInviteFriendsInfo",
	"getInviteFriendsReward" : "/friend/getInviteFriendsReward",
	"getInviteFriendsRewardV2" : "/friend/getInviteFriendsRewardV2",
	"getInviteCountRewards" : "/friend/getInviteCountRewards",
	"H5Login" : "H5Login"
}

ApiList = []

for (var key in urlMap) {
	if (urlMap.hasOwnProperty(key)) {
		ApiList[key] = key
	}
}
